import { Switch } from '@/components/ui/switch';

import { TotemLabel } from './TotemLabel';

type TotemSwitchProps = {
    label?: string;
    sublabel?: string;
    onChange: () => void;
    checked?: boolean;
    disabled?: boolean;
    dataTest?: string;
};

export const TotemSwitch = ({ label, sublabel, onChange, checked = false, disabled, dataTest }: TotemSwitchProps) => {
    return (
        <div className="flex flex-col text-foreground">
            <div className="flex flex-col">
                <TotemLabel>{label}</TotemLabel>
                {sublabel ? <span className="text-muted-foreground text-[13px]">{sublabel}</span> : null}
            </div>
            <div className="relative mt-1.5">
                <Switch checked={checked} onCheckedChange={onChange} disabled={disabled} data-test={dataTest} />
            </div>
        </div>
    );
};
